'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addVisibilityChangeListener = addVisibilityChangeListener;

var _getBrowserPrefix = require('./getBrowserPrefix');

var _getVisibilityChangeNamespace = require('./getVisibilityChangeNamespace');

var _wrapVisibilityCallback = require('./wrapVisibilityCallback');

function addVisibilityChangeListener(callback) {
  var prefix = (0, _getBrowserPrefix.getBrowserPrefix)();
  if (prefix) {
    var visibilityChange = (0, _getVisibilityChangeNamespace.getVisibilityChangeNamespace)(prefix);
    document.addEventListener(visibilityChange, (0, _wrapVisibilityCallback.wrapVisibilityCallback)(callback));
  } else {
    window.addEventListener('focus', (0, _wrapVisibilityCallback.wrapVisibilityCallback)(callback));
    window.addEventListener('blur', (0, _wrapVisibilityCallback.wrapVisibilityCallback)(callback));
  }
}